module.exports = __webpack_public_path__ + "img/farmer.9f56bb5.svg";